// versions 1.0.2.0508
import Vue from 'vue';
import Index from './index';
import axios from 'axios';
import VueRouter from 'vue-router';
// import routers from './routers';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueWechatTitle from 'vue-wechat-title';
import configText from './config/ConfigText';
import {ComponentName, Methods, CdnLibrary, CanvasCommand} from './const/common';
import {InfiniteScroll, Loadmore, Header, Button, Cell, Popup, Radio, CellSwipe, Spinner} from 'mint-ui';

Vue.prototype.$http= axios;
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(VueWechatTitle);
Vue.use(InfiniteScroll);
Vue.use(VueRouter);
Vue.use(Button);
Vue.use(Cell);

Vue.component(Radio.name, Radio);
Vue.component(Popup.name, Popup);
Vue.component(Loadmore.name, Loadmore);
Vue.component(Button.name, Button);
Vue.component(Header.name, Header);
Vue.component(Spinner.name, Spinner);
Vue.component(CellSwipe.name, CellSwipe);
Vue.component('game-preview-box', {
  render: function (createElement) {
    var self = this;
    var pre_div = createElement('div', {
      attrs: {
        "class": "egret-player",
        "style": 'margin: auto;width: 100%;height: 100%;',
        "data-entry-class": "Main",
        "data-orientation": "auto",
        "data-scale-mode": "noScale",
        "data-frame-rate": 30,
        "data-content-width": "540",
        "data-content-height": "960",
        "data-show-paint-rect": false,
        "data-multi-fingered": "2",
        "data-show-fps": "false",
        "data-show-log": "false",
        "data-show-fps-style": "x:0,y:0,size:26,textColor:0xffffff,bgAlpha:0.9"
      }
    });
    console.log(pre_div);
    return pre_div;
  }
});
// routers[0].meta.title = "1111";
// const router = new VueRouter({
//   mode: 'history',
//   routes: routers
// });

window.CanvasCommand = CanvasCommand;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(Index)
})
document.title=configText.title;



// WEBPACK FOOTER //
// ./src/main.js